import { safeSessionGetItem, safeSessionRemoveItem, safeSessionSetItem } from "@utils/storage";

const POSTHOG_DISTINCT_ID_STORAGE_KEY = "posthog-distinct-id";

export function getPersistedPosthogDistinctId(): string | undefined {
  return safeSessionGetItem(POSTHOG_DISTINCT_ID_STORAGE_KEY) || undefined;
}

export function persistPosthogDistinctId(distinctId?: string | null): void {
  if (distinctId) {
    safeSessionSetItem(POSTHOG_DISTINCT_ID_STORAGE_KEY, distinctId);
    return;
  }

  safeSessionRemoveItem(POSTHOG_DISTINCT_ID_STORAGE_KEY);
}

export function withPosthogDistinctId<TQuery extends object>(
  query: TQuery,
): TQuery | (TQuery & { distinctId: string }) {
  const distinctId = getPersistedPosthogDistinctId();

  if (!distinctId) return query;

  return {
    ...query,
    distinctId,
  };
}
